import React from 'react';
import { Avatar, Divider, Row, Col } from 'antd';
import { useQuery } from '@apollo/client';
import { Badge } from '..';
import { getNickName, getLastSubId } from '../../utils/commonUtils';
import { TimeFormatter } from '../../utils/timeParser';
import { GET_LIST_TEAM_LICENSES } from '../../graphql/queries';
import Wrapper from './style';

const Index = (props) => {
  const {
    teamName,
    owner,
    teamId,
    ownerImage,
    description,
    isLicenseActive,
    totalMember,
  } = props;

  const dateFormatter = (param) => {
    const formattedDate = TimeFormatter(param);
    return ` ${formattedDate.date} ${formattedDate.monthName} ${formattedDate.year}`;
  };

  const { data, loading: isLoading } = useQuery(GET_LIST_TEAM_LICENSES, {
    variables: {
      is_expired: null,
      where: {
        deleted_at: null,
        team_id: teamId,
      },
    },
  });
  const listOfLicenses = data?.GetTeamLicenseList?.data || [];

  return (
    <Wrapper>
      <div className="component_team_info_content_wrapper">
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <div className="component_team_info_content_title font-caption_medium black2">
              Team Name
            </div>
            <div className="font-paragraph black1">{teamName ?? '-'}</div>
          </Col>
          <Col span={12}>
            <div className="component_team_info_content_title font-caption_medium black2">
              Owner
            </div>
            <div className="font-paragraph black1">
              <Avatar src={ownerImage} size={24}>
                {getNickName(owner)}
              </Avatar>
              {owner ?? '-'}
            </div>
          </Col>
          <Col span={12}>
            <div className="component_team_info_content_title font-caption_medium black2">
              Member
            </div>
            <div className="font-paragraph black1">
              {totalMember && `${totalMember} Member`}
            </div>
          </Col>
          <Col span={12}>
            <div className="component_team_info_content_title font-caption_medium black2">
              Team ID
            </div>
            <div className="font-paragraph black1">
              {getLastSubId(teamId) ?? '-'}
            </div>
          </Col>
          <Col span={12}>
            <div className="component_team_info_content_title font-caption_medium black2">
              Description
            </div>
            <div className="font-paragraph black1">{description ?? '-'}</div>
          </Col>
          <Col span={12}>
            <Badge
              inactive={!isLicenseActive}
              className="component_team_info_badge"
            >
              {isLicenseActive ? 'Activated' : 'Deactivated'}
            </Badge>
          </Col>
          <Col span={24}>
            <div className="component_team_info_content_title font-caption_medium black2">
              {listOfLicenses?.length === 0 ? 'Pre License' : 'License'}
            </div>
            <div className="component_team_license_text">
              {!isLoading &&
                listOfLicenses.map((item) => {
                  return (
                    <span className="font-paragraph black2" key={item?.id}>
                      {`${item?.license?.name} (Exp: ${
                        item?.team_license_detail?.expired_at
                          ? dateFormatter(item?.team_license_detail?.expired_at)
                          : '-'
                      })`}
                      <br />
                    </span>
                  );
                })}
            </div>
          </Col>
        </Row>
      </div>
      <Divider />
    </Wrapper>
  );
};

export default Index;
